import { makeStyles } from '@material-ui/core';

// Layout only — the preview panel and the input own their own styles.
export const useStyles = makeStyles({
  content: {
    display: 'flex',
    gap: 24
  },
  previewColumn: {
    flex: '0 0 440px'
  },
  customizeColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // 26px heading + 12px = the preview column's 30px header row + 8px, so the
    // instruction text top-aligns with the preview box.
    gap: 12
  }
});
